






































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IInvoiceData, IPaymentData, IInvoice } from "@/interfaces";
import { makePaymentData } from "@/utils";
import MoneyField from "./money-field.vue";
import { PRICE_REQ_RULES, PRICE_REQ_RULES2, TAX_RULE } from "@/validators";
import SigPanel from './../../common/signa/SigPanel.vue'
import LegacyPad from './../../common/signa/LegacyPad.vue'

@Component({ components: { MoneyField, SigPanel, LegacyPad } })
export default class PaymentMethodsComponent extends Vue {
  public ourPaymentData: IPaymentData = makePaymentData({});
  @Prop({ default: null }) paymentData!: IPaymentData | null;

  @Prop({ default: false }) public disabledProp!: boolean;
	
	@Prop({ default: true }) public showPurchaseOrder!: boolean;
  @Prop({ default: false }) public onlyPurchaseOrder!: boolean;
	
	// @Prop({ default: false }) public showAuthNum!: boolean;
	@Prop({ default: false }) public onlyAuthNum!: boolean;

  public priceRules = PRICE_REQ_RULES;
	public priceRules2 = PRICE_REQ_RULES2;
	public taxRules = TAX_RULE;

  @Watch("paymentData", { immediate: true, deep: true })
  onPaymentDataChanged(newval: IPaymentData, oldval: IPaymentData) {
    /*	
			THE ORIGINAL PAYMENT DATA IS STORED ON paymentData
			AND WE MANAGE A COPY ON ourPaymentData
			THEREFORE TO UPDATE THE LATTER AND KEEP IT IN SYNC, 
			WE NEED TO WATCH THE FORMER (paymentData).
		*/
    this.ourPaymentData = { ...newval }; //this.paymentData.Tax;

    this.RefreshPaymentsArray();

    this.CalculateAllAmounts();
  }

// public showAuthNumber: boolean=true;
  public payments: string[] = [];
  public options = {
    penColor: "white",
    backgroundColor: "rgba(0,0,0,0)",
    onEnd: this.onEnd,
  };
  public disabled = false;

  mounted() {
    if (this.paymentData) {
      this.ourPaymentData = { ...this.paymentData };
      this.RefreshPaymentsArray();
    }
    if (this.disabledProp) {
      this.disabled = true;
    }
    // (this.$refs.signaturePad as any).fromDataURL(
    //   this.ourPaymentData.CustomerSignature
    // );
  }

  private RefreshPaymentsArray() {
    this.payments = [];

    if (this.ourPaymentData.PayByCash) this.payments.push("Cash");

    if (this.ourPaymentData.PayByCheck) this.payments.push("Check");

    if (this.ourPaymentData.PayByCreditCard) this.payments.push("Credit Card");

    if (this.ourPaymentData.PayByPurchaseOrder)
      this.payments.push("Purchase Order");

    if (this.ourPaymentData.PayByAuth)
      this.payments.push("Authorization Number");
  }

  onEnd() {
    // const { data } = (this.$refs.signaturePad as any).saveSignature();
    // this.ourPaymentData.CustomerSignature = data;
    // this.NotifyChanges();
  }

  clearSignature() {
    // (this.$refs.signaturePad as any).clearSignature();
    // this.ourPaymentData.CustomerSignature = "";
    // this.NotifyChanges();
  }

	signatureUpdated(){
		this.NotifyChanges()
	}

  updateTax() {
    this.NotifyChanges();
  }

  NotifyChanges() {
    this.CalculateAllAmounts();
    this.$emit("update", this.ourPaymentData); // paidAmounts, this.ourPaymentData.Tax);
  }


	ZeroOrGreater(v:number){
		if (v>=0)return v;
		return 0;
	}

  private CalculateAllAmounts() {
    var paidAmounts = 0;

    {
      /*
				CALCULATE AND SET THE PAID AMOUNTS.
			*/
      if (this.ourPaymentData.PayByCash)
        paidAmounts += this.ZeroOrGreater(this.ourPaymentData.PayByCashAmount);

      if (this.ourPaymentData.PayByPurchaseOrder)
        paidAmounts += this.ZeroOrGreater(this.ourPaymentData.PayByPOAmount);

      if (this.ourPaymentData.PayByCheck)
        paidAmounts += this.ZeroOrGreater(this.ourPaymentData.PayByCheckAmount);

      if (this.ourPaymentData.PayByCreditCard)
        paidAmounts += this.ZeroOrGreater(this.ourPaymentData.PayByCreditCardAmount);

      if (this.ourPaymentData.PayByAuth)
        paidAmounts += this.ZeroOrGreater(this.ourPaymentData.PayByAuthAmount);

      this.ourPaymentData.InvoicePayments = paidAmounts;
    }

    {
      /*
			CALCULATE AND SET TAX AMOUNTS AND BALANCE.
			*/
      var taxable = this.ourPaymentData.Tax;

      var taxPercent = this.$store.getters["AppModule/tax"];

      var subtotal = this.ourPaymentData.InvoiceSubTotal;

      var tax = 0;
      if (taxable) {
        tax = (subtotal * taxPercent) / 100;
      } else {
        tax = 0;
      }

      this.ourPaymentData.InvoiceTax = tax;

      var balance = subtotal + tax - paidAmounts;
      if (balance < 0) balance = 0;

      this.ourPaymentData.InvoiceTotal = balance;
    }
  }

  payOptionsChanged() {
    this.ourPaymentData.PayByCash = !!this.payments.includes("Cash");
    this.ourPaymentData.PayByCheck = !!this.payments.includes("Check");
    this.ourPaymentData.PayByCreditCard = !!this.payments.includes(
      "Credit Card"
    );
    this.ourPaymentData.PayByPurchaseOrder = !!this.payments.includes(
      "Purchase Order"
    );
    this.ourPaymentData.PayByAuth = !!this.payments.includes(
      "Authorization Number"
    );

    this.NotifyChanges();
  }
}
